/* ───────────────────── TEAM BADGE HELPERS ─────────────────────
   Teams are usually named by age group ("U10 Blue"), so a single
   first-letter avatar is always "U". Show the age group instead, and
   tint the circle by the team's chosen color (or one inferred from the
   color word in its name). */
import { BRAND } from "./brand";

const COLOR_WORDS = {
  navy: "#1e3a8a", royal: "#1d4ed8", blue: "#2563eb",
  red: "#dc2626", crimson: "#b91c1c", maroon: "#7f1d1d",
  white: "#f3f4f6", silver: "#cbd5e1", grey: "#6b7280", gray: "#6b7280",
  black: "#111827", gold: "#d97706", yellow: "#eab308",
  lime: "#65a30d", green: "#16a34a", teal: "#0d9488",
  orange: "#ea580c", purple: "#7c3aed", violet: "#7c3aed", pink: "#db2777",
};

// "U10" from the age group or team name; else the first letter.
export function ageLabel(team) {
  const src = (team.ageGroup && team.ageGroup.trim()) || team.name || "";
  const m = String(src).match(/U-?\s?(\d{1,2})/i) || String(team.name || "").match(/U-?\s?(\d{1,2})/i);
  if (m) return "U" + m[1];
  return ((team.name || "?").trim().charAt(0) || "?").toUpperCase();
}

// First color word found in the name → hex; else the brand accent.
export function autoColor(name) {
  const lower = (name || "").toLowerCase();
  for (const [word, hex] of Object.entries(COLOR_WORDS)) {
    if (new RegExp("\\b" + word + "\\b").test(lower)) return hex;
  }
  return BRAND.accent;
}

// Effective badge color: explicit team.color wins, else auto from name.
export function badgeColor(team) {
  if (team.color && /^#?[0-9a-fA-F]{6}$/.test(team.color)) {
    return team.color[0] === "#" ? team.color : "#" + team.color;
  }
  return autoColor(team.name);
}

// Dark or light text for contrast against a hex background.
export function readableText(hex) {
  const h = (hex || "").replace("#", "");
  if (h.length !== 6) return "#ffffff";
  const r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
  const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return lum > 0.62 ? "#1f2937" : "#ffffff";
}
